import { Reducer } from 'redux';

import { ActionType, State } from './validationTypes';

export const initialState: State = {
  isLookingUpAddressBySearchTerm: false,
  isRetrievingAddress: false,
};

const validationReducer: Reducer<State> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.REQUEST_LOOKUP_ADDRESS_BY_SEARCH_TERM:
      return {
        ...state,
        isLookingUpAddressBySearchTerm: true,
      };
    case ActionType.LOOKUP_ADDRESS_BY_SEARCH_TERM_SUCCESS:
      return {
        ...state,
        isLookingUpAddressBySearchTerm: false,
      };
    case ActionType.LOOKUP_ADDRESS_BY_SEARCH_TERM_FAILURE:
      return {
        ...state,
        isLookingUpAddressBySearchTerm: false,
      };

    case ActionType.REQUEST_RETRIEVE_ADDRESS:
      return {
        ...state,
        isRetrievingAddress: true,
      };
    case ActionType.RETRIEVE_ADDRESS_SUCCESS:
      return {
        ...state,
        isRetrievingAddress: false,
      };
    case ActionType.RETRIEVE_ADDRESS_FAILURE:
      return {
        ...state,
        isRetrievingAddress: false,
      };

    default:
      return state;
  }
};

export default validationReducer;
